import compose from 'vegas-js-core/src/functors/compose'

import initApp from '../../../contexts/app/initApp'

import { withRouter } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'

import ArticleChildren from './ArticleChildren'
import { styles } from '../ThingChildren'

class IsRelatedTo extends ArticleChildren
{
    getLocale = () => this.props.locale.things.article.isRelatedTo ;
}

IsRelatedTo.defaultProps =
{
    ...ArticleChildren.defaultProps ,
    member : 'isRelatedTo'
};

IsRelatedTo.propTypes =
{
    ...ArticleChildren.propTypes
};

export default compose( withStyles( styles ) , withRouter , initApp )( IsRelatedTo );